<div [ngClass]="isVerticalList ? 'tools-buttons-vertical-container' : 'tools-buttons-container'">
  <div [ngClass]="isVerticalList ? 'vertical-tools' : 'individual-tools'" id="individualToolsBar">
    <loading [isLoading]="isLoadingButton"></loading>
    <!-- para el panel de locations global -->
      <div *ngIf="isGlobal && !isBranding && showFilter" [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" (click)="this.openFilter()" [matTooltip]="isVerticalList ? '' : 'Filtrar'" id="panelLocationFilterButton">
        <mat-icon *ngIf="ApplyFilter">filter_alt_off</mat-icon>
        <img [src]="'filtrar_boton.svg' | findUrl" *ngIf="!ApplyFilter">
        <span *ngIf="isVerticalList" class="tool-label">Filtrar</span>
      </div>
      <!-- <div *ngIf="isGlobal && isBranding" [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" (click)="this.openAvailabilityFilter()" [matTooltip]="isVerticalList ? '' : 'Filtrar'">
        <mat-icon *ngIf="ApplyAvailabilityFilter">event_busy</mat-icon>
        <mat-icon *ngIf="!ApplyAvailabilityFilter">event_note</mat-icon>
        <span *ngIf="isVerticalList" class="tool-label">Filtrar</span>
      </div> -->
      <div *ngIf="isGlobal && btnDownExcel" [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" (click)="this.getTabExcel()" [matTooltip]="isVerticalList ? '' : 'Descargar lista en formato Excel'" id="panelLocationExcelButton">
        <img [src]="'xls_bton.svg' | findUrl" >
        <span *ngIf="isVerticalList" class="tool-label">Descargar Excel de categoría</span>
      </div>
      <!-- <div *ngIf="isGlobal && 'ServiceAssignmentAnimation' | permissionFilter " [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" (click)="this.startAssignment()" [matTooltip]="isVerticalList ? '' : 'Ver asignación de unidades'">
        <mat-icon>find_replace</mat-icon>
        <span *ngIf="isVerticalList" class="tool-label">Ver asignación de unidades</span>
      </div> -->

      <!-- para el panel de detalles de location -->
      <div *ngIf="hasValetParking && isDetailLocations && 'ValetParking' | permissionFilter" [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" [class.yellow-border]="isValetParking" (click)="ValetParking()" [matTooltip]="isVerticalList ? '' : 'Valet Parking'">
        <!-- <mat-icon *ngIf="!isValetParking">local_parking</mat-icon> -->
        <img *ngIf="!isValetParking" [src]="'valet_parking.svg' | findUrl">
        <img *ngIf="isValetParking" [src]="'crear_valet_parking.svg' | findUrl">
        <span *ngIf="isVerticalList" class="tool-label">Valet Parking</span>
      </div>
      <div *ngIf="isDetailLocations && hasRouteTrace && ('LocationRoute' | permissionFilter) && isTrazabilityAllowed" [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" (click)="getLocationRoute()" [matTooltip]="isVerticalList ? '' : 'Trazabilidad de ruta'">
        <img src="/assets/img/icon_history.png" width="25px">
        <span *ngIf="isVerticalList" class="tool-label">Trazabilidad de ruta</span>
      </div>
      <div *ngIf="blockingObject.isVisibleBlocking && 'BloquearRuptela-L' | permissionFilter">
        <div [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" (click)="OpenBlokingDialog()" [matTooltip]="isVerticalList ? '' : 'Bloqueo de auto'">
          <mat-icon >{{ blockingObject.blockingIcon }}</mat-icon>
          <span *ngIf="isVerticalList" class="tool-label">Bloqueo de auto</span>
        </div>
      </div>
      <!-- <div *ngIf="openCitronellaTicket">
        <div [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" (click)="OpenTicket()" [matTooltip]="isVerticalList ? '' : 'Bloqueo de auto'">
          <mat-icon >store_mall_directory</mat-icon>
          <span *ngIf="isVerticalList" class="tool-label">Crear solicitud de ubicación</span>
        </div>
      </div> -->
      <div *ngIf="canEditLocation()">
        <div [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" (click)="openEditLocationDialog()" [matTooltip]="isVerticalList ? '' : 'Editar'">
          <mat-icon>edit</mat-icon>
          <span *ngIf="isVerticalList" class="tool-label">Editar</span>
        </div>
      </div>
      <div *ngIf="isDetailLocations && !isMonitor">
        <div [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" [ngClass]="{'disabled': isLoadingImages , 'display-none': !isLoadingImages && images?.length < 1 }" (click)="images && images?.length > 0 ? openCarouselPopup() : null" [matTooltip]="isVerticalList ? '' : 'Imagenes'">
          <mat-icon > crop_original </mat-icon>
          <span *ngIf="isVerticalList" class="tool-label">Imágenes</span>
        </div>
      </div>
      <div *ngIf="isDetailLocations && isReloadable">
        <div [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" (click)="refreshDetails()" [matTooltip]="isVerticalList ? '' : 'Sincronizar'">
          <img [src]="'boton_sincronizar.svg' | findUrl" width="25px">
          <span *ngIf="isVerticalList" class="tool-label">Sincronizar</span>
        </div>
      </div>
      <div *ngIf="isDetailLocations && CordX != undefined && CordX != '' && CordY != undefined && CordY != ''">
        <div [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" (click)="openStreetView()" [matTooltip]="isVerticalList ? '' : 'StreetView'">
          <img [src]="'streetview.svg' | findUrl" width="25px">
          <span *ngIf="isVerticalList" class="tool-label">StreetView</span>
        </div>
      </div>
      <!-- <div *ngIf="isDetailLocations && identifier != null && identifier != ''">
        <div [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" [class.yellow-border]="geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible" (click)="openRecurrentPlaces()" [matTooltip]="isVerticalList ? '' : 'Lugares concurridos'">
          <img src="/assets/img/icon_history.png" width="25px">
          <span *ngIf="isVerticalList" class="tool-label">Lugares concurridos</span>
        </div>
      </div> -->
      
      

      <!-- para el panel de Geocercas -->
      <div [ngClass]="isVerticalList && isGeofencePanel ? 'btn-create-geofence' : (isVerticalList ? 'tool-option-vertical' : 'tool-option')" *ngIf="isGeofencePanel && 'AgregarGeocerca' | permissionFilter" (click)="onClickAddGeofence()"  [matTooltip]="isVerticalList ? '' : 'Crear'">
        <mat-icon *ngIf="isVerticalList && isGeofencePanel">add</mat-icon>
        <img *ngIf="!(isVerticalList && isGeofencePanel)" src="assets/img/icon_plus.png" style="width: 25px;">
        <span *ngIf="isVerticalList" class="tool-label">Crear nueva Geocerca</span>
      </div>
      <div [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" *ngIf="isGeofenceDetails && 'EditarGeocerca' | permissionFilter" (click)="onClickEditGeofence()" [matTooltip]="isVerticalList ? '' : 'Editar'">
        <mat-icon>edit</mat-icon>
        <span *ngIf="isVerticalList" class="tool-label">Editar</span>
      </div>
      <div [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" *ngIf="isGeofenceDetails && 'DuplicarGeocerca' | permissionFilter" (click)="onClickDuplicateGeofence()" [matTooltip]="isVerticalList ? '' : 'Duplicar'">
        <mat-icon>control_point_duplicate</mat-icon>
        <span *ngIf="isVerticalList" class="tool-label">Duplicar</span>
      </div>
      <div [ngClass]="isVerticalList ? 'tool-option-vertical' : 'tool-option'" *ngIf="isGeofenceDetails && 'BorrarGeocerca' | permissionFilter" (click)="onClickDeleteGeofence()" [matTooltip]="isVerticalList ? '' : 'Borrar'">
        <mat-icon>delete</mat-icon>
        <span *ngIf="isVerticalList" class="tool-label">Borrar</span>
      </div>
  </div>
</div>
